import React, { memo } from 'react';
import { ToastContainer } from 'react-toastify';

const RGlobalToast = () => {
  return <ToastContainer theme="colored" position="top-right" closeOnClick={true} rtl={false} draggable pauseOnHover />
};

export default memo(RGlobalToast);
